import React, { useContext } from 'react';
import { HomeGraficoContext } from '~/modules/Dashboard/context/listaHomeGraficoContext';
import { getHomeItemService } from '~/modules/Dashboard/services/dashboard.service';
import { AA_DISABLED_BORDER } from '~/modules/Helper/contrast.helper';

/**
 * Label acima do select, compacto para caber no header do Card (~48px).
 * Não altera o layout do .ant-card-head-wrapper (título | extra na mesma linha).
 */
const wrapStyle = {
  display: 'inline-flex',
  flexDirection: 'column',
  alignItems: 'flex-end',
  justifyContent: 'center',
  gap: 0,
  maxHeight: 44,
  lineHeight: 1,
};

const labelStyle = {
  fontSize: 10,
  fontWeight: 600,
  lineHeight: '12px',
  color: '#262626',
  whiteSpace: 'nowrap',
  margin: 0,
  padding: 0,
};

const selectStyle = {
  width: 72,
  height: 26,
  maxHeight: 26,
  padding: '0 4px',
  margin: 0,
  borderRadius: 2,
  border: `1px solid ${AA_DISABLED_BORDER}`,
  fontSize: 12,
  lineHeight: '24px',
  boxSizing: 'border-box',
};

function ExercicioSelect({ id }) {
  const { anoAtual, home, setHome, exercicio, setExercicio } = useContext(
    HomeGraficoContext
  );
  const exercicios = Array.from({ length: 5 }, (_, i) => anoAtual - i);
  const value = exercicio[id] ?? anoAtual;
  const selectId = `home-exercicio-${id}`;

  async function onChange(ano) {
    if (ano) {
      setExercicio(prevState => ({ ...prevState, [id]: ano }));
      const response = await getHomeItemService(id, ano);
      if (response && response.data) {
        const updatedHome = home?.ListaHomeItem.map(item => {
          if (item.Id == response.data.Id) item = response.data;

          return item;
        });
        setHome({ ListaHomeItem: updatedHome });
      }
    }
  }

  return (
    <span style={wrapStyle}>
      <label htmlFor={selectId} style={labelStyle}>
        Exercício
      </label>
      <select
        id={selectId}
        value={value}
        onChange={event => onChange(Number(event.target.value))}
        style={selectStyle}
      >
        {exercicios.map(ano => (
          <option key={ano} value={ano}>
            {ano}
          </option>
        ))}
      </select>
    </span>
  );
}

export default ExercicioSelect;
